import { forEach, startsWith } from 'lodash';
import { getSpecificEnv } from '@availity/env-var';

const specificEnv = getSpecificEnv();

// when doing work in this repo, add a feature flag for your work by adding your ticket number to this array.
// NOTE: the feature array will work on a promotion basis, so any ticket listed in 'stage' will also be available at the 'develop' level.
// NOTE: use the 'txx' array if you want your code available in a specific T-XX env but not in the TEST env.
// NOTE: any feature at the 'stage' level will also be available in the QAP env.
const features = {
  txx: [],
  develop: ['ON-9739', 'ON-12077'],
  stage: [],
};

// NOTE: if the ticket is not found at any level, it is assumed that the feature is not toggled. so if developing local and want your feature toggled code to be enabled, place your ticket number at 'txx' level at the minimum.
export const isFeatureEnabled = (ticketNumber) => {
  // iterate through features object and find which level the ticket exists in.
  let ticketLevel;
  forEach(features, (tickets, envKey) => {
    const ticketFound = tickets.indexOf(ticketNumber) >= 0;
    if (ticketFound) {
      ticketLevel = envKey;
    }
  });

  // first, automatically enable feature at the local level - needs valid ticket to ensure feature is properly toggled
  if (ticketLevel && specificEnv === 'local') {
    return true;
  }

  // given the ticketLevel, find out if the ticket is enabled based on the current specific env.
  let output = false;
  switch (ticketLevel) {
    case 'txx': {
      output = !!(startsWith(specificEnv, 't') && specificEnv !== 'test');
      break;
    }
    case 'develop': {
      output = !!startsWith(specificEnv, 't');
      break;
    }
    case 'stage': {
      output = !!(startsWith(specificEnv, 'q') || startsWith(specificEnv, 't'));
      break;
    }
    default: {
      output = false;
    }
  }

  return output;
};
